import {Flex} from "@chakra-ui/react";
import User from "./Notice";

function NoticeSetup() {
    return (
        <Flex direction='column' pt={{base: "120px", md: "75px"}}>
            <User
                title={"User Table"}
                captions={["SN","Title","Description","Image","Enabled", "Status", ""]}
            />
        </Flex>
    );
}

export default NoticeSetup;